<template>
  <page>
    <div class="number">{{ code }}</div>
    <div class="title">用户需知</div>
    <div class="desc">
      1.
      功能说明：取货码功能是为了避免因疫情等特殊原因造成您无法正常收货的情况。
    </div>
    <div class="desc">
      2.
      如何使用：如果遇到疫情封路特殊情况，在司机按照您的要求将货物送到新地址时，您将取货码告知司机即可完成收货。
    </div>
    <div class="desc">
      3.
      每日更新：您的取货码一天内会更换两次，分别是每天中午12:00以及下午19:00；请将最新的取货码告知司机。
    </div>
    <div class="desc">
      4.
      特殊说明：取货码功能是为了应对特殊情况，所以在可以正常货物交接的情况下该功能将不会开放；如果给您造成不便，请您谅解。
    </div>
  </page>
</template>
<script>
import { API } from '@/api'
import { initAppNavBar } from '@/utils/native_interactions/native_bar/app'
export default {
  beforeRouteEnter(to, from, next) {
    initAppNavBar()
    document.title = '取货码'
    next()
  },
  data() {
    return {
      code: '--'
    }
  },
  created() {
    API.account
      .pickupCode()
      .then(res => {
        const { code, message } = res
        if (code) {
          this.code = code
        } else {
          this.code = message
        }
      })
      .catch(this.$catch)
  }
}
</script>
<style lang="scss" scoped>
.number {
  font-size: 0.8rem;
  line-height: 5rem;
  font-weight: bold;
  text-align: center;
  color: #262626;
}
.title {
  padding: 0 0.24rem;

  font-size: 0.28rem;
  line-height: 0.4rem;
  color: #8c8c8c;
}
.desc {
  padding: 0 0.24rem;

  font-size: 0.24rem;
  line-height: 0.4rem;
  color: #8c8c8c;
}
</style>
